module.exports = __webpack_public_path__ + "img/round-lock-24px.d35ce48d.svg";